import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  
  private channel = new BehaviorSubject<any>({});
  sharedChannel = this.channel.asObservable();

  constructor() { }

  setChannel(channel: any) {
    this.channel.next(channel);
  }

}
